import React from "react";
import "./App.css";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import AuthorizedDistributor from "./components/AuthorizedDistributor";
import ProductsSection from "./components/ProductsSection";
import IndustriesSection from "./components/IndustriesSection";
import WhyUsSection from "./components/WhyUsSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <AuthorizedDistributor />
        <ProductsSection />
        <IndustriesSection />
        <WhyUsSection />
        <ContactSection />
      </main>
      <Footer />
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
